export abstract class WidgetController {
    private config: any;
    private element: HTMLElement;
    constructor(element: HTMLElement, config: any) {
        this.config = config;
        this.element = element;
    }
    protected getElement(): HTMLElement {
        return this.element;
    }
    protected getConfig(): any {
        return this.config;
    }

    protected install(): void {}

    protected beforeUpdate(): any {
        return null;
    }
    protected afterUpdate(
        beforeUpdateData: any,
        updateData: any,
        successResponse: any
    ): void {}
    protected updateFailed(beforeUpdateData: any, errorResponse: any): void {}

    private isUpdatePending = false;
    protected autoUpdate() {
        const self = this;
        setTimeout(function () {
            if (!self.isUpdatePending) {
                self.update();
            }

            self.autoUpdate();
        }, self.config.update.interval);
    }

    protected update() {
        const self = this;
        self.isUpdatePending = true;
        const beforeData = self.beforeUpdate();

        $.get({
            data: { isAjax: true },
            url: self.config.update.url,
            success: function (data: any, status: string, xhr: any) {
                try {
                    self.afterUpdate(beforeData, data, {
                        response: data,
                        status: status,
                        xhr: xhr,
                    });
                } catch {}

                self.isUpdatePending = false;
            },
            error: function (xhr: any, status: string, errorThrown: string) {
                try {
                    self.updateFailed(beforeData, {
                        xhr: xhr,
                        status: status,
                        errorThrown: errorThrown,
                    });
                } catch {}

                self.isUpdatePending = false;
            },
        });
    }
}

export abstract class HtmlUpdateWidgetController extends WidgetController {
    protected afterUpdate(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ): void {
        const self = this;
        $(self.getElement()).html(html);
        this.updateHtml(beforeUpdateData, html, successResponse);
    }

    protected updateHtml(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ): void {}
}

export class ExternalScriptWidgetController {
    private isUpdatePending = false;
    private element: HTMLElement;
    private config: any;

    constructor(element: HTMLElement, config: any) {
        this.element = element;
        this.config = config;
        if (
            config.update.type == 'auto' &&
            config.update.interval > 0 &&
            !!config.update.url
        ) {
            this.autoRefresh();
        }
    }

    protected autoRefresh() {
        const self = this;
        setTimeout(function () {
            if (!self.isUpdatePending) {
                self.update();
            }

            self.autoRefresh();
        }, self.config.update.interval);
    }
    private callScript(script: string, ...params: any[]) {
        const self = this;
        try {
            const evaluatedScript = eval(script);
            if (typeof evaluatedScript == 'function') {
                return evaluatedScript.apply(self, params);
            }

            return evaluatedScript;
        } catch {}
    }
    public update() {
        const self = this;
        self.isUpdatePending = true;
        let beforeData = null;
        if (self.config.scripts.beforeupdate) {
            beforeData = self.callScript(
                self.config.scripts.beforeupdate,
                self,
                self.element
            );
        }

        $.get({
            data: { isAjax: true },
            url: self.config.update.url,
            success: function (data: any, status: string, xhr: any) {
                try {
                    if (self.config.scripts.afterupdate) {
                        self.callScript(
                            self.config.scripts.afterupdate,
                            beforeData,
                            { response: data, status: status, xhr: xhr },
                            self,
                            self.element
                        );
                    }
                } catch {}
                self.isUpdatePending = false;
            },
            error: function (xhr: any, status: string, errorThrown: string) {
                try {
                    if (self.config.scripts.updatefailed) {
                        self.callScript(
                            self.config.scripts.updatefailed,
                            beforeData,
                            {
                                xhr: xhr,
                                status: status,
                                errorThrown: errorThrown,
                            },
                            self,
                            self.element
                        );
                    }
                } catch {}

                self.isUpdatePending = false;
            },
        });
    }
}
